import { BaseModel } from '@/models/BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { createModel } from '@kp/js-model';

export class KorrekturWaermeerzeugerWarmwasser extends BaseModel {
    // properties
    id: number | null = null;
    created: Dayjs | null = null;
    modified: Dayjs | null = null;
    creator_id: number | null = null;
    modifier_id: number | null = null;

    kombination: number | null = null;
    waermeerzeuger_heizung_1_id: number | null = null;
    waermeerzeuger_heizung_2_id: number | null = null;
    waermeerzeuger_warmwasser_1_id: number | null = null;
    waermeerzeuger_warmwasser_2_id: number | null = null;
    korrektur_waermeerzeuger_warmwasser_1_id: number | null = null;
    korrektur_waermeerzeuger_warmwasser_2_id: number | null = null;
    energie_waermequelle_heizung_1_id: number | null = null;
    energie_waermequelle_heizung_2_id: number | null = null;
    energie_waermequelle_warmwasser_1_id: number | null = null;
    energie_waermequelle_warmwasser_2_id: number | null = null;
    korrektur_energie_waermequelle_1_id: number | null = null;
    korrektur_energie_waermequelle_2_id: number | null = null;
    bemerkung: string | null = null;

    // view fields
    energie_waermequelle_heizung_1_i18n_key: string | null = null;
    energie_waermequelle_heizung_2_i18n_key: string | null = null;
    energie_waermequelle_warmwasser_1_i18n_key: string | null = null;
    energie_waermequelle_warmwasser_2_i18n_key: string | null = null;
    korrektur_energie_waermequelle_1_i18n_key: string | null = null;
    korrektur_energie_waermequelle_2_i18n_key: string | null = null;
    korrektur_waermeerzeuger_warmwasser_1: string | null = null;
    korrektur_waermeerzeuger_warmwasser_2: string | null = null;
    waermeerzeuger_heizung_1: string | null = null;
    waermeerzeuger_heizung_2: string | null = null;
    waermeerzeuger_warmwasser_1: string | null = null;
    waermeerzeuger_warmwasser_2: string | null = null;

    public mutations(): MutationsObject {
        return {
            created: (val) => dayjs(val),
            modified: (val) => dayjs(val),
        };
    }

    getClassName(): string {
        return 'KorrekturWaermeerzeugerWarmwasser';
    }
}

export async function createNewKorrekturWaermeerzeugerWarmwasser(): Promise<KorrekturWaermeerzeugerWarmwasser> {
    const korrekturwaermeerzeugerwarmwasser = createModel(KorrekturWaermeerzeugerWarmwasser, {});

    await korrekturwaermeerzeugerwarmwasser.save();
    return korrekturwaermeerzeugerwarmwasser;
}

export class KorrekturWaermeerzeugerWarmwasserCollection extends BaseCollection<KorrekturWaermeerzeugerWarmwasser> {
    protected modelCls = KorrekturWaermeerzeugerWarmwasser;

    public getModelClassName(): string {
        return 'KorrekturWaermeerzeugerWarmwasser';
    }
}
